import styled, { css } from 'styled-components';

export const TAG_STYLES = css`
  //display: inline-block;
  font-weight: bold;
  font-size: 12px;
  line-height: 24px;

  border-radius: 12px;
  padding-left: 15px;
  padding-right: 15px;
`;

export const TagSC = styled.div<{
  backgroundColor: string;
  textColor: string;
  clickable?: boolean;
}>`
  .tag {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ backgroundColor }) => backgroundColor};
    color: ${({ textColor }) => textColor};
    ${TAG_STYLES};
    cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};

    .star {
      margin-right: 4px;
    }
  }
`;
